import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Navigation from "./components/Navigation";
import Add from "./components/pages/Add";
import Edit from "./components/pages/Edit";
import Home from "./components/pages/Home";

function App() {
    return (
        <Router>
            <Navigation />
            <Routes>
                <Route path="/" element={<Navigate replace to="/books" />} />
                <Route path="/books" element={<Home />} />
                <Route path="/books/add" element={<Add />} />
                <Route path="/books/edit/:bookId" element={<Edit />} />
            </Routes>
        </Router>
    );
}

export default App;
